import {
  parseAsString,
  useQueryState,
} from 'nuqs';
import {
  type FC,
  useEffect,
} from 'react';
import {
  Navigate,
  useNavigate,
} from 'react-router';
import {
  DEFAULT_LOGGED_PAGE,
  RoutePaths,
} from 'shared/routes.js';

export const LoginPage: FC = () => {
  const [token] = useQueryState('internalLoginToken', parseAsString);
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      void navigate(DEFAULT_LOGGED_PAGE);
    }
  }, [token]);

  if (!token) {
    return <Navigate to={RoutePaths.HOME} />;
  }

  return <Navigate to={DEFAULT_LOGGED_PAGE} />;
};
